"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateWebpackDEVServer = void 0;
var ModuleFederation_helper_1 = require("../../../helpers/ModuleFederation.helper");
var webpack_common_1 = require("./webpack.common");
function generateWebpackDEVServer(options, deps) {
    var ENV_CONFIG = options.ENV_CONFIG, sharedMappings = options.sharedMappings;
    var ModuleFederationPlugin = deps.webpack.container.ModuleFederationPlugin, merge = deps.webpackMerge.merge, mf = deps.mf;
    var common = (0, webpack_common_1.generateAngularCommonConfig)(options, deps);
    var serverConfig = ModuleFederation_helper_1.ModuleFederationHelper.buildRemoteModuleFederationConfigs(common.__mfeName__, common.sharedModuleFederationDeps(mf.share, sharedMappings), ENV_CONFIG).serverConfig;
    var devServerConfig = merge(common.config, {
        mode: "development",
        target: "async-node",
        output: {
            uniqueName: common.__mfeName__ + "AngularDevServer",
            publicPath: ENV_CONFIG.getRemoteEndpointBy(common.type) +
                ":" +
                common.devServerPort +
                "/",
            clean: true,
            asyncChunks: false,
        },
        optimization: {
            runtimeChunk: false,
        },
        resolve: {
            alias: __assign({}, sharedMappings.getAliases()),
        },
        plugins: [
            new ModuleFederationPlugin(serverConfig),
            sharedMappings.getPlugin(),
        ],
    });
    return devServerConfig;
}
exports.generateWebpackDEVServer = generateWebpackDEVServer;
